import { Message } from "domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { LinkedinLocationMapping } from "domain/entities/linkedinlocationmapping";
import { ILinkedinLocationMappingRepository } from "domain/contracts/linkedinlocationmapping.contract";

class LinkedinLocationMappingRepository implements ILinkedinLocationMappingRepository {
  async getAll(filter?: any): Promise<Message<{ data: LinkedinLocationMapping[]; page: number; size: number; count: number }>> {
    const response = await httpClient.get(`/locationMappings`, {
      params: filter,
    });
    return response.data;
  }

  async create(input: { originalLocation: string; standardizedLocation: string; lastModifiedBy?: string | null }): Promise<Message<LinkedinLocationMapping>> {
    const response = await httpClient.post(`/locationMappings`, {
      data: input,
    });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/locationMappings/${id}`);
    return response.data;
  }
}

export default new LinkedinLocationMappingRepository();
